import { combineReducers } from 'redux';
import WeatherReducer from './Weather';
import WeatherErrorReducer from './WeatherError';

const rootReducer = combineReducers({
	weather: WeatherReducer,
	weatherError: WeatherErrorReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js